import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { FaChevronUp } from "react-icons/fa";
import { Navbar, Header, Footer } from "../components";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

const BiayaPendidikanPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["tuitionFees"],

    queryFn: async () => {
      const response = await customAxios.get("tuition-fees");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  const [openIndex, setOpenIndex] = useState(null);
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderContent = () => {
    if (isLoading)
      return (
        <div className="flex flex-col gap-6 max-w-[1152px] w-full animate-pulse">
          <div className="w-full py-8 bg-gray-200 rounded"></div>
          <div className="w-full py-8 bg-gray-200 rounded"></div>
          <div className="w-full py-8 bg-gray-200 rounded"></div>
        </div>
      );
      
    if (!data) return null;

    return (
      <div className="flex flex-col gap-4 max-w-[1152px] w-full">
        {data.map(({ image, faculty_name_id, faculty_name_en }, index) => {
          const isOpen = openIndex === index;
          const title =
            currentLanguage === "en" ? faculty_name_en : faculty_name_id;

          return (
            <div key={index} className="mb-1 overflow-hidden border rounded-md">
              <button
                className="flex items-center justify-between w-full p-4 transition duration-300 bg-neutral-20 hover:bg-neutral-40"
                onClick={() => toggleAccordion(index)} // Pass the index here
              >
                <span className={`${styles.textLMedium}`}>{title}</span>

                <FaChevronUp
                  className={`transform transition-transform duration-300 ${
                    isOpen ? "rotate-0" : "rotate-180"
                  }`}
                />
              </button>

              {isOpen && (
                <div className="flex justify-center p-4 bg-white">
                  <img
                    src={image}
                    alt={`Biaya pendidikan ${title}`}
                    className="w-full h-auto max-w-full rounded-md shadow-sm"
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("tuition.header")} />
      <main
        className={`${styles.paddingX} flex flex-col gap-4 py-20 items-center min-h-[600px]`}
      >
        {renderContent()}
      </main>
      <Footer />
    </>
  );
};

export default BiayaPendidikanPage;
